export const SAVE_TOKEN = "SAVE_TOKEN";
export const DELETE_TOKEN = "DELETE_TOKEN";
export const LOGIN_INFO = "LOGIN_INFO";
export const SET_TRADES = "SET_TRADES";
export const EMPTY_TRADES = "EMPTY_TRADES";
export const SET_STOCK = "SET_STOCK";
export const CLEAR_STOCK = "CLEAR_STOCK";
export const SET_AUTH = "SET_AUTH";
export const SET_PROVINCES = "SET_PROVINCES";
export const NEW_UPLOAD = "NEW_UPLOAD";
export const SET_CREDIT = "SET_CREDIT";
export const SET_LOAD = "SET_LOAD";
export const SET_LEVEL = "SET_LEVEL";
export const SET_MOBILE = "SET_MOBILE";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_CODE = "SET_CODE";
export const SET_MYNAME = "SET_MYNAME";
export const SET_PERMISSION = "SET_PERMISSION";
export const SET_DASHBOARDSUMMARY = "SET_DASHBOARDSUMMARY";

